module.exports = __webpack_public_path__ + "img/logo.a5a55f1c.svg";